<template>
  <div class="base-empty-component app-flex-column-center" :class="size">
    <img :src="imgPic" class="empty-img" />
    <span
      class="text font-color-desc"
      :class="size == 'small' ? 'font-12' : 'font-18'"
    >
      <slot name="text">暂无内容</slot>
    </span>
  </div>
</template>

<script>
import emptyBase from '@/assets/img/common/empty-base.png'

export default {
  props: {
    imgPic: { type: String, default: emptyBase },
    size: {
      validate(val) {
        return ['normal', 'small'].includes(val)
      },
      default: 'normal'
    }
  }
}
</script>

<style lang="scss" scoped>
.base-empty-component {
  width: 100%;
  align-items: center;
  position: relative;
  .empty-img {
    width: 440px;
    max-width: 100%;
    object-fit: contain;
  }
  .text {
    position: absolute;
    bottom: 31px;
    width: 100%;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
  }
  &.small {
    .empty-img {
      width: 30%;
      margin: 0 auto;
    }
    .text {
      bottom: 9px;
    }
  }
}
</style>
